module.exports = __webpack_public_path__ + "f6c4c65627a2698855eff56cc97e144a.svg";